import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';

import SustainabilityHome from './sustainabilityPage/sustainabilityHome';
import { PrefilteredResourceLibraryItemsProvider } from '../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import { useAboutSustainabilityContent } from '../graphql/pimcore/modules/siteContent/hooks/useAboutSustainabilityContent';
import DebouncedLoader from './common/DebouncedLoader';

const SustainabilityPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useAboutSustainabilityContent();

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <PrefilteredResourceLibraryItemsProvider
                    initialFilters={{
                        // On change of resourceTypeKeys, please also update the related Pimcore role
                        // - Full_About-Sustainability role
                        resourceTypeKeys: [
                            'Certification',
                            'Compliance Report',
                            'Material Declaration',
                            'Quality Document',
                        ],
                    }}
                >
                    <Box
                        width="100%"
                        component="main"
                        sx={{
                            padding: 0,
                            flexGrow: 0,
                            p: 0,
                        }}
                    >
                        <SustainabilityHome cmsContent={contentTree} />
                    </Box>
                </PrefilteredResourceLibraryItemsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default SustainabilityPage;
